import { put, takeEvery, all, call } from 'redux-saga/effects'

import { FETCH_QUEUES, FETCH_QUEUE_COUNTS, TRIGGER_SERVICE, RETRY_DLQ_MESSAGES, CLEAR_DLQ } from '../actions/types'
import {
  fetchQueueCountsSuccess,
  fetchQueueCountsFailure,
  fetchQueuesFailure,
  fetchQueuesSuccess,
  triggerServiceSuccess,
  triggerServiceFailure,
  retryDLQMessagesSuccess,
  retryDLQMessagesFailure,
  clearDLQSuccess,
  clearDLQFailure,
} from '../actions/queueActions'
import queueService from '../services/queueService'

function* handleFetchQueues(action) {
  try {
    const { accessToken } = action.payload
    const results = yield call(queueService.fetchQueues, accessToken)
    yield put(fetchQueuesSuccess(results))
  } catch (err) {
    console.error(err, 'Error fetching SQS queues')
    yield put(fetchQueuesFailure(err))
  }
}

function* handleFetchQueueCounts(action) {
  const { queueId, accessToken } = action.payload

  try {
    const results = yield call(queueService.fetchQueueCounts, queueId, accessToken)
    yield put(fetchQueueCountsSuccess(queueId, results))
  } catch (err) {
    console.error(err, `Error fetching SQS queue count for queue ${queueId}`)
    yield put(fetchQueueCountsFailure(queueId, err))
  }
}

function* handleTriggerService(action) {
  const { queueId, accessToken } = action.payload

  try {
    yield call(queueService.triggerService, queueId, accessToken)
    yield put(triggerServiceSuccess(queueId))
  } catch (err) {
    console.error(err, `Error triggering service ${queueId}`)
    yield put(triggerServiceFailure(queueId, err))
  }
}

function* handleRetryDLQMessages(action) {
  const { queueId, accessToken } = action.payload

  try {
    yield call(queueService.retryDLQMessages, queueId, accessToken)
    yield put(retryDLQMessagesSuccess(queueId))
  } catch (err) {
    console.error(err, `Error retrying DLQ messages for queue ${queueId}`)
    yield put(retryDLQMessagesFailure(queueId, err))
  }
}

function* handleClearDLQ(action) {
  const { queueId, accessToken } = action.payload

  try {
    yield call(queueService.clearDLQ, queueId, accessToken)
    yield put(clearDLQSuccess(queueId))
  } catch (err) {
    console.error(err, `Error clearing all messages for queue ${queueId}`)
    yield put(clearDLQFailure(queueId, err))
  }
}

function* watchQueueSagas() {
  yield all([
    takeEvery(FETCH_QUEUES, handleFetchQueues),
    takeEvery(FETCH_QUEUE_COUNTS, handleFetchQueueCounts),
    takeEvery(TRIGGER_SERVICE, handleTriggerService),
    takeEvery(RETRY_DLQ_MESSAGES, handleRetryDLQMessages),
    takeEvery(CLEAR_DLQ, handleClearDLQ),
  ])
}

export default watchQueueSagas
